import React, { useState } from 'react';
import { FaTimes, FaCheck, FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa';
import { Z_INDEX } from '../../constants/zIndex.js';

export const NotificationContext = React.createContext();

// Composant factice exporté pour forcer Vite à détecter le préambule JSX
// Ce composant n'est jamais utilisé mais permet à Vite de détecter le JSX
export const _ForceJSXDetection = () => <div style={{ display: 'none' }} />;

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    title: '',
    message: '',
    onConfirm: null,
    onCancel: null
  });

  const showNotification = (type, title, message, duration = 4000) => {
    const id = Date.now();
    const notification = {
      id,
      type,
      title,
      message,
      duration
    };
    
    setNotifications(prev => [...prev, notification]);
    
    setTimeout(() => {
      removeNotification(id);
    }, duration);
  };

  const removeNotification = (id) => {
    setNotifications(prev => prev.filter(notif => notif.id !== id));
  };

  const showConfirm = (title, message, onConfirm, onCancel = null) => {
    setConfirmModal({
      show: true,
      title,
      message,
      onConfirm: () => {
        onConfirm();
        setConfirmModal({ show: false, title: '', message: '', onConfirm: null, onCancel: null });
      },
      onCancel: () => {
        if (onCancel) onCancel();
        setConfirmModal({ show: false, title: '', message: '', onConfirm: null, onCancel: null });
      }
    });
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success':
        return <FaCheck className="h-5 w-5" />;
      case 'error':
        return <FaExclamationTriangle className="h-5 w-5" />;
      case 'warning':
        return <FaExclamationTriangle className="h-5 w-5" />;
      default:
        return <FaInfoCircle className="h-5 w-5" />;
    }
  };

  const getNotificationColor = (type) => {
    switch (type) {
      case 'success':
        return 'bg-green-500 text-white';
      case 'error':
        return 'bg-red-500 text-white';
      case 'warning':
        return 'bg-yellow-500 text-white';
      default:
        return 'bg-blue-500 text-white';
    }
  };

  return (
    <NotificationContext.Provider value={{ showNotification, showConfirm }}>
      {children}
      
      <div
        className="fixed top-4 right-4 space-y-2 pointer-events-none"
        style={{ zIndex: Z_INDEX.TOAST }}
      >
        {notifications.map((notification) => (
          <div
            key={notification.id}
            className={`pointer-events-auto rounded-lg shadow-lg p-4 max-w-sm w-full ${getNotificationColor(notification.type)} animate-slide-in-right`}
          >
            <div className="flex items-center">
              <div className="flex-shrink-0">
                {getNotificationIcon(notification.type)}
              </div>
              <div className="ml-3 flex-1">
                <p className="text-sm font-medium">{notification.title}</p>
                <p className="text-sm opacity-90">{notification.message}</p>
              </div>
              <div className="ml-auto pl-3">
                <button
                  onClick={() => removeNotification(notification.id)}
                  className="inline-flex hover:opacity-70 transition-opacity"
                >
                  <FaTimes className="h-4 w-4" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {confirmModal.show && (
        <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-md flex items-center justify-center z-[9999]">
          <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
            <div className="flex items-center mb-4">
              <div className="flex-shrink-0">
                <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-lg font-medium text-gray-900">{confirmModal.title}</h3>
              </div>
            </div>
            
            <div className="mb-6">
              <p className="text-sm text-gray-500">{confirmModal.message}</p>
            </div>
            
            <div className="flex justify-end space-x-3">
              <button
                onClick={confirmModal.onCancel}
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Annuler
              </button>
              <button
                onClick={confirmModal.onConfirm}
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      )}
    </NotificationContext.Provider>
  );
}

// useNotifications a été déplacé dans useNotifications.jsx (SOLUTION 2)



